// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.
import.meta.globEager('./**/*_channel.js')
